// Base path configuration for different environments
// In development, use empty string or "/"
// In production, use empty string or "/"
const getBasePath = (): string => {
  // REACT_APP_PUBLIC_URL can be set in .env files to override default behavior
  // Development: leave empty or set to ""
  // Production: set to ""
  if (process.env.REACT_APP_PUBLIC_URL !== undefined) {
    return process.env.REACT_APP_PUBLIC_URL;
  }
  
  // Fallback to process.env.PUBLIC_URL (set by CRA based on homepage field in package.json)
  // This will be "/" in production (from package.json) and undefined in development
  return process.env.PUBLIC_URL || '';
};

export const BASE_PATH = getBasePath();

// Helper function to get full path with base path for public assets
// Usage: getPublicAssetPath('/le_long.png') -> '/le_long.png'
export const getPublicAssetPath = (path: string): string => {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  // Remove trailing slash from BASE_PATH if exists
  const base = BASE_PATH.endsWith('/') ? BASE_PATH.slice(0, -1) : BASE_PATH;
  return `${base}${normalizedPath}`;
};

// Alias for backward compatibility
export const getPublicUrl = getPublicAssetPath;

// API URL configuration
// Normalize API base URL - ensure it doesn't end with /api to avoid duplication
// REACT_APP_API_URL can be:
// - Development: "http://localhost:8000" (without /api)
// - Production: "https://legitimu.id/api" (with /api)
// We normalize it to remove /api suffix so endpoints can use /api/... consistently
const getApiBaseUrl = (): string => {
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  
  // Remove trailing slashes
  let normalized = apiUrl.replace(/\/+$/, '');
  
  // If URL ends with /api, remove it (we'll add it back in the endpoint)
  // This handles cases where REACT_APP_API_URL is set to "https://legitimu.id/api"
  // if (normalized.endsWith('/api')) {
  //   normalized = normalized.slice(0, -4);
  // }
  
  return normalized;
};

export const API_BASE_URL = getApiBaseUrl();
